import React, { useState } from 'react';
import {
    Toolbar,
    Typography,
    Button,
} from '@mui/material';
import { useTheme } from '@mui/material/styles';
import { useTranslation } from 'react-i18next';
import ModelDeleteSelectedItems from '../Models/ModelDeleteSelectedItems';

const TableBulkToolbar = ({
    selectedCount,
    onBulkDelete,
    isBulkDeleting,
    bulkDeleteDisabled = false,
}) => {
    const theme = useTheme();
    const isDark = theme.palette.mode === 'dark';
    const { i18n } = useTranslation();
    const lng = i18n.language || 'en';
    const isArabic = lng === 'ar';

    const [confirmOpen, setConfirmOpen] = useState(false);

    if (!selectedCount || !onBulkDelete) return null;

    const handleOpenConfirm = () => {
        setConfirmOpen(true);
    };

    const handleCloseConfirm = () => {
        if (isBulkDeleting) return;
        setConfirmOpen(false);
    };

    const handleConfirmDelete = async () => {
        await onBulkDelete();   // تنفيذ الحذف الفعلي
        setConfirmOpen(false);  // إغلاق المودال بعد التنفيذ
    };

    return (
        <>
            <Toolbar
                sx={{
                    px: 2.5,
                    py: 1,
                    bgcolor: isDark ? '#111827' : '#E3F2FD',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'space-between',
                    borderBottom: (t) => `1px solid ${t.palette.divider}`,
                }}
            >
                <Typography
                    sx={{ flex: '1 1 50%' }}
                    color="inherit"
                    variant="subtitle2"
                    component="div"
                >
                    {isArabic
                        ? `تم اختيار ${selectedCount}`
                        : `${selectedCount} selected`}
                </Typography>

                <Button
                    variant="contained"
                    color="error"
                    size="small"
                    onClick={handleOpenConfirm}
                    disabled={isBulkDeleting || bulkDeleteDisabled || !onBulkDelete}
                    title={bulkDeleteDisabled ? (isArabic ? "لا تملك صلاحية حذف المحدد" : "No bulk delete permission") : ""}
                >
                    {isBulkDeleting
                        ? isArabic
                            ? 'جاري الحذف...'
                            : 'Deleting...'
                        : isArabic
                            ? 'حذف المحدد'
                            : 'Delete selected'}
                </Button>
            </Toolbar>

            {/* مودال تأكيد الحذف الجماعي */}
            <ModelDeleteSelectedItems
                confirmOpen={confirmOpen}
                handleCloseConfirm={handleCloseConfirm}
                isArabic={isArabic}
                selectedCount={selectedCount}
                isBulkDeleting={isBulkDeleting}
                handleConfirmDelete={handleConfirmDelete}
            />
        </>
    );
};

export default TableBulkToolbar;
